import React, { useEffect, useState } from "react";
import Header from "../../Components/Header";
import { useLocation, useNavigate } from "react-router-dom";
import MaterialTable from "../../Components/Table/MaterialTable";
import { tableEye } from "../../common/Assets/imgs";
import { FaSearch } from "react-icons/fa";
import { get, post, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import toast from "react-hot-toast";
// import { toast } from "react-toastify";

const VehicleTransport = () => {
  const navigation = useNavigate();
  const location = useLocation();
  const STORAGE_KEYS = {
    transport: "tm_transport_context",
    type: "tm_context_type",
  };
  const readStorage = (key) => {
    try {
      const raw = sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (err) {
      return null;
    }
  };
  const writeStorage = (key, value) => {
    try {
      if (value === undefined || value === null) return;
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (err) {
      // ignore storage errors
    }
  };
  const [context, setContext] = useState(() => {
    const state = location.state || {};
    return {
      datas: state.datas ?? readStorage(STORAGE_KEYS.transport),
      type: state.type ?? readStorage(STORAGE_KEYS.type),
    };
  });
  const { datas, type } = context;
  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState(1);
  // const [totalCount, setTotalCount] = useState(1);
  const tabs = [
    { name: "Transport Details", path: "/view-transport" },
    { name: "Vehicles", path: "/vehicle-transport" },
    { name: "Drivers", path: "/drivers-transport" },
    { name: "Bookings", path: "/transport-bookings" },
  ];

  console.log("location", datas);
  useEffect(() => {
    const state = location.state || {};
    if (state?.datas || state?.type) {
      setContext((prev) => ({
        datas: state?.datas ?? prev.datas,
        type: state?.type ?? prev.type,
      }));
      if (state?.datas) writeStorage(STORAGE_KEYS.transport, state.datas);
      if (state?.type) writeStorage(STORAGE_KEYS.type, state.type);
    }
  }, [location.state]);

  // const statusChanger = (id,status) =>{
  //     const payload = new FormData();
  //     payload.append("user_id",id)
  //     payload.append("status",!status)
  //     post(URLS.VEHICLE_TRANSPORT_STATUS,payload) 
  //     .then((res)=>{
  //         if(res?.status === "success"){
  //           //   getList();
  //             toast.success(res?.message);
  //         }
  //     })
  //     .catch((err)=>{
  //         console.log("err",err)
  //     })
  // }

  const statusChanger = (id, currentStatus) => {
    put(`${URLS.VEHICLE_TRANSPORT_STATUS}${id}/`, {
      status: currentStatus === true ? false : true,
    })
      .then((res) => {
        if (res?.status === "success") {
          toast.success(res?.message);
          getList(search, pagination); // refresh table
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };


  const [adminList, setAdminList] = useState([]);
  //  const adminList = [
  //     {
  //         sno: "01",
  //         vehicleType: "cargo Truck-20FT",
  //         maxVolume: "30 TON",
  //         price: "150",
  //         vehiclename:"TN05BD4622",
  //     },
  //     {
  //         sno: "02",
  //         vehicleType: "cargo Truck-20FT",
  //         maxVolume: "30 TON",
  //         price: "150",
  //         vehiclename:"TN05BD4622",
  //     },
  //     {
  //         sno: "03",
  //         vehicleType: "cargo Truck-20FT",
  //         maxVolume: "30 TON",
  //         price: "150",
  //         vehiclename:"TN05BD4622",
  //     },
  // ];

  const pageSize = 10;

  const columns = [
    {
      header: "S.No",
      // accessorFn: (row, index) => index + 1,
           accessorFn: (row, index) =>
    (pagination - 1) * pageSize + index + 1,
      id: "serial_no",
    },
    {
      accessorKey: "vehicle_no",
      header: "Vehicle No",
    },
    {
      accessorKey: "vehicle_type_name",
      header: "Vehicle Type",
    },
    // {
    //     accessorKey: "maxVolume",
    //     header: "Max Volume",
    // },
    // {
    //     accessorKey: "price",
    //     header: "Price (KM)",
    //     Cell: ({ cell }) => {
    //         const value = cell.getValue();
    //         return (
    //             // <div className={`${value === "Active" ? 'statusactive' : 'statusdeactive'}`} >
    //             <span className='text-success'>
    //                 {`₹${value}`}
    //             </span>
    //             // </div>
    //         );
    //     },
    // },
    {
      accessorKey: "status",
      header: "Status",
      Cell: ({ cell, row }) => {
        return (
          // <button
          //   className={`border-0 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13"
          // ${cell.getValue() ? "active-btn" : "deactive-btn"} `}
          //   onClick={() => statusChanger(row?.original?.id, row?.original?.status)}
          // >
          //   {cell.getValue() ? "Active" : "Deactive"}
          // </button>
          <span className={` ${cell.getValue() ? "status-active" : "status-inactive"} `}
            onClick={() => statusChanger(row?.original?.id, row?.original?.status)}
          >
            {cell.getValue() ? "Active" : "Deactive"}
          </span>
        );
      },
    },
    {
      id: "action", // ✅ important when no accessorKey
      header: "Action",
      Cell: ({ row }) => (
        <div onClick={() => {
          writeStorage(STORAGE_KEYS.transport, datas);
          writeStorage(STORAGE_KEYS.type, "view");
          sessionStorage.setItem("tm_vehicle_context", JSON.stringify(row.original));
          navigation('/addvehicle-transport', {
            state: {
              data: row.original,
              type: 'view',
              datas,
            }
          })
        }}
        >
          <img src={tableEye} alt="" className='tableeye' />
        </div>
      ),
    },
  ];



  // ----------- BACK BUTTON -----------
  const handleBack = () => {
    navigation(-1);
  };

  const handleTabClick = (tab) => {
    if (datas) writeStorage(STORAGE_KEYS.transport, datas);
    if (type) writeStorage(STORAGE_KEYS.type, type);
    navigation(tab.path, { state: { datas, type } });
  };

  const getList = async (src, page) => {
    if (!datas?.id) {
      return;
    }
    try {
      const res = await get(`${URLS.VEHICLE_TRANSPORT_LIST}${datas?.id}/?search=${src}&page=${page}`);
      console.log('res', res);
      if (res?.status === "success") {
        setAdminList(res?.data || [])
      }
    }
    catch (err) {
      console.log('err', err);

    }
  }

  useEffect(() => {
    getList(search, pagination);
  }, [search, pagination])

  useEffect(() => {
    if (!datas?.id) {
      toast.error("Transport details missing. Please open from Transport Details.");
    }
  }, [datas]);

  return (
    <>
      <Header />
      <div
        style={{
          marginTop: "6rem",
          paddingLeft: "15px",
          paddingRight: "10px",
        }}
      >
        {/* <div className="section">
          <h3 onClick={handleBack} className="section-titlez mb-0">
            Swift way Transports
          </h3>
        </div> */}

        <div className="d-flex justify-content-between align-items-center flex-wrap mb-3 gap-3">

          {/* LEFT TITLE */}
          {/* <h3 className="m-0 fw-bold fs-5 text-black">Vehicle Master</h3> */}
          <div className="section">
            <h3 onClick={handleBack} className="section-titlez mb-0">
              {/* Swift way Transports */}
              {datas?.transport_name || ''}
            </h3>
          </div>
          {/* RIGHT SECTION */}
          <div className="d-flex align-items-center gap-3">

            {/* SEARCH BOX */}
            <div className="search-box d-flex align-items-center px-3"
            >
              <input
                type="text"
                placeholder="Search"
                className="border-0 outline-none bg-transparent"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <div className="ms-2 searchdote" >|</div>
              <FaSearch color='#7A52AB' className="ms-1" />
            </div>

            {/* ADD BUTTON */}
            <button onClick={() => {
              writeStorage(STORAGE_KEYS.transport, datas);
              writeStorage(STORAGE_KEYS.type, "add");
              sessionStorage.removeItem("tm_vehicle_context");
              navigation('/addvehicle-transport',
                {
                  state: {
                    type: "add",
                    datas
                  }
                }
              )
            }} style={{ backgroundColor: "#F98425" }} className="btn text-white fw-semibold px-4 py-2">
              + Add Vehicle
            </button>

          </div>

        </div>

        {/* Tabs */}
        <div className="tabs mb-0 ms-3">
          {tabs.map((tab, index) => (
            <button
              key={index}
              onClick={() => handleTabClick(tab)}
              className={`tab-btn ${location.pathname === tab.path ? "active" : ""
                }`}
            >
              {tab.name}
            </button>
          ))}
        </div>
        <MaterialTable columns={columns} data={adminList || []}
          setPagination={setPagination}
          pagination={pagination}
        />

      </div>
    </>
  );
};

export default VehicleTransport;
